import Header from "../Header";
import Breadcrumb from "../Breadcrumb";
import Contact from "../Contact/Contact";
import Footer from "../Footer";

const ContactPage = () => {

  const pathData = [
    { path: '/', title: 'Home' },
    { path: '/contact', title: 'Contact' }
  ];

  return (
    <>
      <Header logoColor="dark" />
      <Breadcrumb pathData={pathData} />
      <Contact />
      <Footer />
    </>
  );
};

export default ContactPage;
